import React, { useState, useEffect } from 'react';
import PeopleCardSmall from '../components/people-card-small';
import { useTranslation } from 'react-i18next';
import '../styles/alumni.css';

const Alumni = ({ finalUsers }) => {
    const { t } = useTranslation('people');
    const [activeTab, setActiveTab] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const ITEMS_PER_PAGE = 12; 
    
    const rolesWithInactiveMembers = Object.keys(finalUsers)
        .filter(role => 
            finalUsers[role] && 
            finalUsers[role].some(person => !person.is_active)
        );
    
    useEffect(() => {
        if (rolesWithInactiveMembers.length > 0 && !activeTab) {
            setActiveTab(rolesWithInactiveMembers[0]);
        }
    }, [rolesWithInactiveMembers, activeTab]);
    
    useEffect(() => {
        setCurrentPage(0);
    }, [activeTab]);
    
    if (rolesWithInactiveMembers.length === 0) return null;
    
    const goToPrevPage = () => {
        setCurrentPage(prev => Math.max(0, prev - 1));
    };
    
    const goToNextPage = () => {
        setCurrentPage(prev => {
            const maxPage = Math.ceil(inactiveMembers.length / ITEMS_PER_PAGE) - 1;
            return Math.min(maxPage, prev + 1);
        });
    };
    
    const inactiveMembers = activeTab 
        ? finalUsers[activeTab].filter(person => !person.is_active)
        : [];
    
    const totalPages = Math.ceil(inactiveMembers.length / ITEMS_PER_PAGE);
    const currentMembers = inactiveMembers.slice(
        currentPage * ITEMS_PER_PAGE, 
        (currentPage + 1) * ITEMS_PER_PAGE
    );
    
    const getTabTranslationKey = (role) => {
        return role === 'Lab Coordinator' ? 'lab_coordinators' : role;
    };
    
    return (
        <div className="alumni-container">
            <h2 className="alumni-title">{t('alumni') || 'Alumni'}</h2>
            
            {/* Tabs navigation - centered */}
            <div className="alumni-tabs-container">
                <div className="alumni-tabs">
                    {rolesWithInactiveMembers.map(role => (
                        <button 
                            key={role}
                            className={`alumni-tab ${activeTab === role ? 'active' : ''}`}
                            onClick={() => setActiveTab(role)}
                        >
                            {t(`roles.plural.${getTabTranslationKey(role)}`)}
                        </button>
                    ))}
                </div>
            </div>
            
            {/* Tab content with pagination */}
            {activeTab && (
                <div className="alumni-content">
                    <div className="alumni-grid">
                        {currentMembers.map(person => (
                            <div key={person.id} className="alumni-card-wrapper">
                                <PeopleCardSmall 
                                    display_name={person.display_name}
                                    image={person.image}
                                />
                            </div>
                        ))}
                    </div>
                    
                    {totalPages > 1 && (
                        <div className="alumni-pagination">
                            <button 
                                className="nav-button" 
                                onClick={goToPrevPage} 
                                disabled={currentPage === 0}
                                aria-label="Previous page"
                            >
                                &#8592;
                            </button>
                            <span className="page-info">
                                {currentPage + 1} / {totalPages}
                            </span>
                            <button 
                                className="nav-button" 
                                onClick={goToNextPage} 
                                disabled={currentPage === totalPages - 1}
                                aria-label="Next page"
                            >
                                &#8594;
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Alumni;